import { useContext, useMemo } from 'react';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { ChatContextItem, ChatContextType } from '@trinity/chat';
import { useHeaderContext } from '../context';

export function useContextSelectoryDisplayValue() {
  const {
    pendingContext,
    pendingContextType,
  } = useHeaderContext();
  const session = useContext(ActiveChatSessionContext);

  return useMemo(() => {
    if (pendingContext) {
      return getContextDisplayText(pendingContextType, pendingContext);
    }

    if (session.context?.type === ChatContextType.Agent) {
      // return trunc(session.context.data.name, 15);
      return session.context.data.name;
    }

    return getContextDisplayText(session.context?.type);
  }, [pendingContextType, session.context.data, session.context?.type]);
}

function getContextDisplayText(contextType: ChatContextType, context?: ChatContextItem): string {
  switch (contextType) {
    case ChatContextType.Document:
      return 'Document';
    case ChatContextType.Folder:
      return 'Folder';
    case ChatContextType.Transcript:
      return 'Transcript';
    case ChatContextType.Global:
      return 'Everything';
    case ChatContextType.KolProfile:
      return 'Profile';
    case ChatContextType.Agent: {
      return context.name;
    }
    case ChatContextType.Brand:
      return 'Brand';
    case ChatContextType.Project:
      return 'Project';

    default:
      throw new UnreachableCaseError(contextType);
  }
}